export default "__VITE_ASSET__VIU5vNG1__"